module.exports = __webpack_public_path__ + "static/media/arrow_up.a1a53c76.svg";